module.exports = __webpack_public_path__ + "img/sx.283485ca.svg";